var exports = {
  "tB": "ApplicationDetail.module__page___cV9sVH",
  "Vr": "ApplicationDetail.module__pageHeader___cV9sVH",
  "d1": "ApplicationDetail.module__heroCard___cV9sVH",
  "CI": "ApplicationDetail.module__heroTop___cV9sVH",
  "ZY": "ApplicationDetail.module__heroTitle___cV9sVH",
  "Uz": "ApplicationDetail.module__metaInput___cV9sVH",
  "WA": "ApplicationDetail.module__detailGrid___cV9sVH",
  "fP": "ApplicationDetail.module__columnStack___cV9sVH",
  "E7": "ApplicationDetail.module__sectionSpacer___cV9sVH",
  "Nr": "ApplicationDetail.module__card___cV9sVH",
  "Wg": "ApplicationDetail.module__cardDanger___cV9sVH",
  "MY": "ApplicationDetail.module__cardHeader___cV9sVH",
  "JJ": "ApplicationDetail.module__cardTitle___cV9sVH",
  "Dc": "ApplicationDetail.module__cardSubtitle___cV9sVH",
  "zI": "ApplicationDetail.module__cardBody___cV9sVH",
  "tx": "ApplicationDetail.module__secretRow___cV9sVH",
  "cD": "ApplicationDetail.module__secretActions___cV9sVH",
  "PZ": "ApplicationDetail.module__fieldStack___cV9sVH",
  "rP": "ApplicationDetail.module__redirectList___cV9sVH",
  "bs": "ApplicationDetail.module__redirectRow___cV9sVH",
  "C2": "ApplicationDetail.module__redirectActions___cV9sVH",
  "py": "ApplicationDetail.module__redirectRemoveButton___cV9sVH",
  "t_": "ApplicationDetail.module__createRedirectButton___cV9sVH",
  "PM": "ApplicationDetail.module__scopeGrid___cV9sVH",
  "bk": "ApplicationDetail.module__fieldLabel___cV9sVH",
  "Jb": "ApplicationDetail.module__scopeList___cV9sVH",
  "LR": "ApplicationDetail.module__botPermissionList___cV9sVH",
  "_": "ApplicationDetail.module__scopeItem___cV9sVH",
  "wS": "ApplicationDetail.module__scopeCheckbox___cV9sVH",
  "$o": "ApplicationDetail.module__scopeLabel___cV9sVH",
  "Ud": "ApplicationDetail.module__avatarRow___cV9sVH",
  "_Q": "ApplicationDetail.module__avatarPreview___cV9sVH",
  "rZ": "ApplicationDetail.module__avatarPlaceholder___cV9sVH",
  "Jm": "ApplicationDetail.module__tagRow___cV9sVH",
  "vb": "ApplicationDetail.module__discriminatorInput___cV9sVH",
  "jY": "ApplicationDetail.module__validationBox___cV9sVH",
  "JE": "ApplicationDetail.module__bannerRow___cV9sVH",
  "HF": "ApplicationDetail.module__builderResult___cV9sVH",
  "Ml": "ApplicationDetail.module__loadingState___cV9sVH",
  "cy": "ApplicationDetail.module__helperText___cV9sVH",
  "RJ": "ApplicationDetail.module__dangerContent___cV9sVH",
  "n7": "ApplicationDetail.module__dangerActions___cV9sVH",
  "z3": "ApplicationDetail.module__error___cV9sVH",
  "sM": "ApplicationDetail.module__srOnly___cV9sVH",
};

module.exports = exports;
